import React from "react";

const PrivacyPolicy = () => (
  <main className="wrap" role="main" aria-labelledby="policy-title" style={{
    padding: "2rem",
    maxWidth: 800,
    margin: "0 auto",
    borderRadius: "12px",
    boxShadow: "0 6px 20px rgba(15,23,42,0.06)",
    background: "linear-gradient(180deg, #fff, #fafafa)"
  }}>
    <h1 id="policy-title">Privacy Policy</h1>
    <div className="meta" style={{fontSize: ".9rem", color: "#6b7280", marginBottom: 18}}>Last updated: September 26, 2025</div>

    <h2>1. Introduction</h2>
    <p>We respect your privacy. This Privacy Policy explains how we collect, use, and protect your information when you use our website or services.</p>

    <h2>2. Information We Collect</h2>
    <ul>
      <li>Personal details (name, email, phone number) when you contact us.</li>
      <li>Project or business information you share with us.</li>
      <li>Website usage data (IP address, browser type, cookies, analytics).</li>
    </ul>

    <h2>3. How We Use Your Information</h2>
    <ul>
      <li>To provide and improve our services.</li>
      <li>To respond to inquiries and communicate with you.</li>
      <li>For billing and administrative purposes.</li>
      <li>To analyze website performance and enhance user experience.</li>
    </ul>

    <h2>4. Sharing of Information</h2>
    <p>We do not sell or rent your personal information. We may share data only with:</p>
    <ul>
      <li>Trusted service providers (e.g., hosting, analytics, payment processing).</li>
      <li>Legal authorities if required by law.</li>
    </ul>

    <h2>5. Data Security</h2>
    <p>We take reasonable measures to protect your data from unauthorized access, disclosure, or misuse.</p>

    <h2>6. Cookies</h2>
    <p>Our website may use cookies to improve functionality and track usage. You can adjust cookie settings in your browser.</p>

    <h2>7. Your Rights</h2>
    <p>You may request access, correction, or deletion of your personal data by contacting us (see contact details below).</p>

    <h2>8. Third-Party Links</h2>
    <p>Our website may contain links to third-party sites. We are not responsible for their privacy practices.</p>

    <h2>9. Changes to this Policy</h2>
    <p>We may update this Privacy Policy from time to time. Updates will be posted on this page with a revised date.</p>

    <h2>10. Contact Us</h2>
    <p>If you have questions, contact us at:</p>
    <p className="contact" style={{marginTop: 18, fontWeight: 600, color: "#0f172a"}}>CodePy</p>
    <p><a href="mailto:info@talhaanis.com">info@talhaanis.com</a></p>

    <footer style={{marginTop: 26, fontSize: ".85rem", color: "#6b7280", borderTop: "1px solid #eef2f7", paddingTop: 12}}>
      <p>If you need to make a request regarding your personal data (access, correction, or deletion), please email <a href="mailto:info@talhaanis.com">info@talhaanis.com</a>. This policy is provided for informational purposes and does not constitute legal advice. Consider consulting legal counsel to ensure compliance with privacy laws applicable to your business and users.</p>
    </footer>
  </main>
);

export default PrivacyPolicy;